import React, { useState, FormEvent } from "react";

import rv1 from "../../images/shop/shop-single/review/img-1.jpg";
import rv2 from "../../images/shop/shop-single/review/img-2.jpg";

type TabKey = "description" | "review";

const ProductTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>("description");
  const [rating, setRating] = useState<number>(0);

  const toggle = (tab: TabKey) => setActiveTab(tab);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // handle review submit here
  };

  return (
    <div className="row">
      <div className="col col-xs-12">
        <div className="product-info">
          {/* Tabs header */}
          <div className="tabs-header nav-tabs" role="tablist" aria-label="Product information tabs">
            <button
              type="button"
              className={`tab-link ${activeTab === "description" ? "active" : ""}`}
              role="tab"
              aria-selected={activeTab === "description"}
              aria-controls="tab-description"
              onClick={() => toggle("description")}
            >
              Description
            </button>
            <button
              type="button"
              className={`tab-link ${activeTab === "review" ? "active" : ""}`}
              role="tab"
              aria-selected={activeTab === "review"}
              aria-controls="tab-review"
              onClick={() => toggle("review")}
            >
              Review
            </button>
          </div>

          {/* Tabs content */}
          <div className="tabs-content">
            {activeTab === "description" && (
              <div id="tab-description" role="tabpanel" aria-labelledby="Description">
                <div id="Schedule">
                  <p>
                    Samsa woke from troubled dreams, he found himself transformed in his bed into a
                    horrible vermin. He lay on his armour-like back, and if he lifted his head a
                    little he could see his brown belly, slightly domed and divided by arches into
                    stiff sections. The bedding was hardly able to cover it and seemed ready to
                    slide off any moment. His many legs, pitifully thin compared with the size of
                    the rest of him.
                  </p>
                  <p>
                    The bedding was hardly able to cover it and seemed ready to slide off any moment.
                    His many legs, pitifully thin compared with the size of him… Samsa woke from
                    troubled dreams, he found himself transformed in his bed into a horrible vermin.
                  </p>
                </div>
              </div>
            )}

            {activeTab === "review" && (
              <div id="tab-review" role="tabpanel" aria-labelledby="Review">
                <div className="row">
                  <div className="col col-lg-10 col-12">
                    <div className="client-rv">
                      <div className="client-pic">
                        <img src={rv1} alt="Reviewer 1" />
                      </div>
                      <div className="details">
                        <div className="name-rating-time">
                          <div className="name-rating">
                            <div>
                              <h4>Jenefar Willium</h4>
                            </div>
                            <div className="product-rt">
                              <span>25 Sep 2023</span>
                              <div className="rating">
                                <i className="fa fa-star" />
                                <i className="fa fa-star" />
                                <i className="fa fa-star" />
                                <i className="fa fa-star" />
                                <i className="fa fa-star-o" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="review-body">
                          <p>
                            There are many variations of passages of Lorem Ipsum available, but the majority have
                            suffered alteration in some form, by injected humour, or randomised words which don't look.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="client-rv">
                      <div className="client-pic">
                        <img src={rv2} alt="Reviewer 2" />
                      </div>
                      <div className="details">
                        <div className="name-rating-time">
                          <div className="name-rating">
                            <div>
                              <h4>Maria Bannet</h4>
                            </div>
                            <div className="product-rt">
                              <span>28 Sep 2023</span>
                              <div className="rating">
                                <i className="fa fa-star" />
                                <i className="fa fa-star" />
                                <i className="fa fa-star" />
                                <i className="fa fa-star" />
                                <i className="fa fa-star-o" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="review-body">
                          <p>
                            There are many variations of passages of Lorem Ipsum available, but the majority have
                            suffered alteration in some form, by injected humour, or randomised words which don't look.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Review form */}
                  <div className="col col-lg-12 col-12 review-form-wrapper">
                    <div className="review-form">
                      <h4>Add a review</h4>
                      <p>Your email address will not be published. Required fields are marked *</p>

                      <form onSubmit={handleSubmit}>
                        <div className="give-rat-sec">
                          <p>Your rating *</p>
                          <div className="give-rating" role="radiogroup" aria-label="Your rating">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <label key={star} aria-label={`${star} star${star > 1 ? "s" : ""}`}>
                                <input
                                  type="radio"
                                  name="stars"
                                  value={star}
                                  checked={rating === star}
                                  onChange={() => setRating(star)}
                                />
                                {Array.from({ length: star }).map((_, i) => (
                                  <span key={i} className="icon">★</span>
                                ))}
                              </label>
                            ))}
                          </div>
                        </div>

                        <div>
                          <input type="text" className="form-control" placeholder="Name *" required />
                        </div>
                        <div>
                          <input type="email" className="form-control" placeholder="Email *" required />
                        </div>
                        <div>
                          <textarea className="form-control" placeholder="Review *" required />
                        </div>

                        <div className="rating-wrapper">
                          <div className="submit">
                            <button type="submit" className="theme-btn">
                              Post review
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductTabs;
